import { createTrackUiEvents } from '@bluecodecom/tracking';

import { TrackingEvents, trackingService } from '../service';
import { HandyparkenUiVocabulary } from './trackUi.types';

/**
 * Reports an interaction twice — the catalogued universal event and this app's
 * legacy one — for as long as the migration needs both (catalog rule
 * `dual-fire`):
 *
 * ```ts
 * trackUi.buttonTapped(
 *   { button_name: 'select_ticket' },
 *   'Park: Select Ticket: Clicked',
 * );
 * ```
 *
 * `screen_name` is filled in from the last displayed screen rather than passed;
 * see `screenContext` in `libs/tracking`. Everything else, including why the
 * universal event goes to the unprefixed base service, lives in
 * `createTrackUiEvents` — this file only binds handyparken's service and its
 * vocabulary to it.
 */
const trackUi = createTrackUiEvents<HandyparkenUiVocabulary, TrackingEvents>(
  trackingService,
);

export default trackUi;
